import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHypertrackerFavoritesMenuItem = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_1982_14801)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M8.00006 1.33337L10.0694 5.81871L14.9747 6.40071L11.3481 9.75404L12.3107 14.5994L8.00006 12.1867L3.68939 14.6L4.65206 9.75471L1.02539 6.40004L5.93139 5.81804L8.00006 1.33337Z",
			stroke: "currentColor",
			strokeWidth: 1.33333,
			strokeLinejoin: "round"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1982_14801",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgHypertrackerFavoritesMenuItem;
